import type { ItemType, PageId } from "core/entities";
import { useEffect, useRef } from "react";
import { useAddUserLog } from "./useUserLog";

export function useLogComponentMount<T extends ItemType>(
  type: T,
  id: T extends "Page" ? PageId : string
) {
  const isFirstMountRef = useRef(true);
  const addLog = useAddUserLog();
  useEffect(() => {
    (async () => {
      if (isFirstMountRef.current) {
        isFirstMountRef.current = false;
        await addLog(type, id);
      }
    })();
  }, [addLog, id, type]);
}
